import React, { useEffect, useState } from 'react'
import UnitCountTwo from './child/UnitCountTwo'
import RevenueGrowthOne from './child/RevenueGrowthOne'
import EarningStaticOne from './child/EarningStaticOne'
import CampaignStaticOne from './child/CampaignStaticOne'
import ClientPaymentOne from './child/ClientPaymentOne'
import CountryStatusOne from './child/CountryStatusOne'
import TopPerformanceOne from './child/TopperformanceOne'
import LatestPerformanceOne from './child/LatestPerformanceOne'
import LastTransactionOne from './child/LastTransactionOne'
import { API_URL, LOCATION_ID, TOKEN } from '..'
import axios from 'axios'
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";

const DashBoardLayerTwo = () => {
  const [data, setData]=useState([])
  let currentUser = JSON.parse(localStorage.getItem('user'))
  
  const [summary, setSummary]= useState(
    {
      
      totalInvoicesCount: 0,
      totalInvoiceAmountCount: 0,
      paidInvoiceCount: 0,
      paidInvoiceAmountCount: 0,
      overdueInvoiceCount: 0,
      overdueInvoiceAmountCount: 0
    }
      
  )
  const fetchDashboardSummary = async ()=>{
    
    let url;
    if(currentUser?.roles?.role ==='admin'){
      url = API_URL+'/api/invoice/dashboard?locationId='+LOCATION_ID
    }else{
      url = API_URL+'/api/invoice/dashboard/user/'+currentUser?.id+'?locationId='+LOCATION_ID;
    }
    const api = await fetch(url , {method :'GET' });
    const json = await api.json();
    if(api.status ==200){
        setSummary(json?.summary || {
          totalInvoicesCount: 0,
          totalInvoiceAmountCount: 0,
          paidInvoiceCount: 0,
          paidInvoiceAmountCount: 0,
          overdueInvoiceCount: 0,
          overdueInvoiceAmountCount: 0
        });
    }
  }
  const fetchInvoices =  async()=>{
    setLoading(true)
      const user = JSON.parse(localStorage.getItem('user'));
      if(!user){
        window.location.href='/sign-in'
      }else{
        let headersList = {
          "Accept": "*/*",
          "Content-Type": "application/json"
         }
         const currentUser = JSON.parse(localStorage.getItem('user'));
         let url ;
         if(currentUser?.roles?.role=='admin'){
          url = API_URL+`/api/invoice/get/invoice`;
         }else{
          url = API_URL+`/api/invoice/get/user/invoice/${currentUser?.id}`;
         }
        let response = await fetch(url, { 
          method: "GET",
          headers: headersList
        });
        const data = await response.json();
        setLoading(false)
        setData(data)
      }
      
  }
  useEffect(()=>{
    fetchInvoices();
    fetchDashboardSummary()
  },[1])
  const [loading, setLoading] = useState(false);
    const [results, setResults] = useState([]);

    const locationIds = currentUser?.roles?.locationIds

    const fetchLocationDetails = async (locationId) => {
        const options = {
            method: 'GET',
            url: `https://services.leadconnectorhq.com/locations/${locationId}/`,
            headers: {
                Authorization: `Bearer ${TOKEN}`, // Replace with your actual API key
                Version: '2021-07-28',
                'Content-Type': 'application/json',
                Accept: 'application/json'
            }
        };

        try {
            const { data } = await axios.request(options);
            return {
                id: locationId,
                name: data.location?.name || 'Unknown Name',
                info: data.location // Full location object (address, phone, etc.)
            };
        } catch (error) {
            console.error(`Error fetching location ${locationId}:`, error.message);
            return {
                id: locationId,
                name: 'Error',
                info: { error: error.message }
            };
        }
    };

    const fetchAllLocations = async () => {
        setLoading(true);
        const allResults = [];
        for (const id of locationIds) {
            const result = await fetchLocationDetails(id);
            allResults.push(result);
            
            // Optional: Add delay to respect rate limits (e.g., 100ms)
            await new Promise(resolve => setTimeout(resolve, 100));
        }
        setResults(allResults);
        // Save all results to localStorage on success
        // localStorage.setItem('locations', JSON.stringify(allResults));
       
        setLoading(false);
    };
    console.log(currentUser)
    useEffect(()=>{
      if(currentUser){
        fetchAllLocations()
      }
    },[1])
    return (
    <section className="row gy-4">

     <div className='row'>
      <div className='col-md-4'>
        <label className='label' htmlFor='location'>Select Location</label>
      <select id='location' className='form-control'>
        {
          results.filter((item)=>item.name !== 'Error').map((e)=>(<option value={e.id}>{e.name}</option>))
        }
      </select>
      </div>
     </div>
      
          <div className="mt-4 mb-20 mt-20">
          <div className="col-xxl-12">
        <div className="row gy-4">
        <Link className="col-xxl-3 col-sm-6" to={'/invoices/all'}>
          <div>
            <div className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-1">
              <div className="card-body p-0">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                  <div className="d-flex align-items-center gap-2">
                    <span className="mb-0 w-48-px h-48-px bg-primary-600 flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6 mb-0">
                      <Icon icon="mingcute:user-follow-fill" className="icon" />
                    </span>
                    <div>
                      <span className="mb-2 fw-medium text-secondary-light text-sm">
                        Total Invoices
                      </span>
                      <br></br>
                       {/* <span style={{fontWeight:'bold'}}>{summary.totalInvoicesCount}</span> */}
                      <h6 className="fw-semibold">{summary.totalInvoicesCount}</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </Link>
          <Link className="col-xxl-3 col-sm-6" to={'/invoices/paid'}>
          <div >
            <div className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-2">
              <div className="card-body p-0">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                  <div className="d-flex align-items-center gap-2">
                    <span className="mb-0 w-48-px h-48-px bg-success-main flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6">
                      <Icon icon="mingcute:user-follow-fill" className="icon" />
                    </span>
                    <div>
                      <span className="mb-2 fw-medium text-secondary-light text-sm">
                        Paid Invoices
                      </span>
                      <br></br>
                       {/* <span style={{fontWeight:'bold'}}>{summary.paidInvoiceCount}</span> */}
                      <h6 className="fw-semibold">{summary.paidInvoiceCount}</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </Link>
          <Link className="col-xxl-3 col-sm-6" to={'/invoices/overdue'}>
          <div >
            <div className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-4">
              <div className="card-body p-0">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                  <div className="d-flex align-items-center gap-2">
                    <span className="mb-0 w-48-px h-48-px bg-danger-main flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6">
                      <Icon icon="mingcute:user-follow-fill" className="icon" />
                    </span>
                    <div>
                      <span className="mb-2 fw-medium text-secondary-light text-sm">
                        Overdue Invoice
                      </span>
                      <br></br>
                       {/* <span style={{fontWeight:'bold'}}>{summary.overdueInvoiceCount}</span> */}
                      <h6 className="fw-semibold">{summary.overdueInvoiceCount}</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </Link>
          
        </div>
      </div>
  
          </div>
        
      {/* LastTransactionOne */}
      {/* <LastTransactionOne /> */}
    </section>

  )
}

export default DashBoardLayerTwo